<script setup>
  import FieldValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/FieldValueRenderer.vue'
  import { fieldCommonProps } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

  defineProps({
    modelValue: Date,
    field: fieldCommonProps.field,
  })
</script>

<template>
  <FieldValueRenderer :field="field">
    <template #label>
      <slot name="label">{{ field.key }}</slot></template
    >
    <slot>
      {{ modelValue }}
    </slot>
  </FieldValueRenderer>
</template>

<style lang="scss" scoped></style>
